import React from "react";
import { Container, Grid, Typography, Box } from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ListItem from './ListItem';
import { useT } from "contexts/TranslationContext";
const PRIMARY_GREEN = '#34986C';

// --- Essential Tools Section Component ---
const EssentialToolsSection = () => {
    const t = useT();
    const tools = [
        {
            title: t("tools.detailedTimeTracking"),
            description: t("tools.detailedTimeTrackingDesc"),
        },
        {
            title: t("tools.flexiblePricing"),
            description: t("tools.flexiblePricingDesc"),
        },
        {
            title: t("tools.insightfulReporting"),
            description: t("tools.insightfulReportingDesc"),
        },
    ];

    // Split the tools data for the two-column layout
    const column1 = [tools[0], tools[2]]; 
    const column2 = [tools[1]]; 

    return (
        <Box
            component="section"
            sx={{
                bgcolor: 'white',
                pt: { xs: 8, md: 12 },
                pb: { xs: 10, md: 16 },
                px: { xs: 4, sm: 8, lg: 16 },
                width: '100%',
                maxWidth: 'lg',
                mx: 'auto',
            }}
        >
            <Typography
                variant="h4"
                component="h2"
                textAlign="center"
                sx={{
                    fontWeight: 800,
                    color: 'grey.900',
                    mb: 3,
                    fontSize: { xs: '2rem', sm: '2.5rem' }
                }}
            >
                {t("tools.title")}
            </Typography>
            <Typography
                variant="body1"
                textAlign="center"
                sx={{
                    color: 'grey.700',
                    maxWidth: 700,
                    mx: 'auto',
                    mb: { xs: 8, md: 10 }
                }}
            >
                {t("tools.subtitle")}
            </Typography>
            <Grid container spacing={{ xs: 4, md: 8 }} justifyContent="center">
                {/* Left Column (Time Tracking, Reporting) */}
                <Grid item xs={12} md={5}>
                    {column1.map((item, index) => (
                        <ListItem 
                            key={index} 
                            title={item.title} 
                            description={item.description} 
                        />
                    ))}
                </Grid>

                {/* Right Column (Flexible Pricing) */}
                <Grid item xs={12} md={5}>
                    {column2.map((item, index) => (
                        <ListItem 
                            key={index} 
                            title={item.title} 
                            description={item.description} 
                        />
                    ))}
                </Grid>
            </Grid>
        </Box>
    );
};

export default EssentialToolsSection;